import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { selectWeek, addTimesheetDate } from '../../store/actions/timesheet/timesheetActions';

class WeeksDropdown extends Component {

  constructor(props) {
    super(props);
    this.excludeDates = [];
    this.datePicked = '';
  }

  getWeeks = () => {
    let weeksList = [];
    let existingWeeks = [];

    let weeks = this.props.common.weeksInYear;
    const timesheets = this.props.timesheets.timesheets || [];
    if (timesheets.length) {
      existingWeeks = timesheets.map(timesheet => timesheet.week_number) ;

      if (this.props.action === "ENTER_TIMESHEET" && existingWeeks.length) {
        weeks = weeks.filter(week => !existingWeeks.includes(week.week_num));
      }
    }
    

    weeksList = weeks.map((week, key) => {
      return (
        <option key={key} value={week.week_num}>{week.start} - {week.end}</option>
      )
    })

    return weeksList;
  }

  getDaysWithSheets = () => {
    const timesheets = this.props.timesheets.timesheets || [];
    let daysWithSheets = [];
    if (timesheets.length) {
      timesheets.forEach(timesheet => {
        const startDate = moment(timesheet.start_date);
        const endDate = moment(timesheet.end_date);

        for (var m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'days')) {
          const newDate = new Date(m.format('YYYY-MM-DD'));
          daysWithSheets.push(newDate);
          if (!this.datePicked || this.datePicked < newDate) {
            this.datePicked = newDate;
          }
        }
      })
    }

    return daysWithSheets;
  }

  render() {

    if (!this.excludeDates || !this.excludeDates.length) {
      this.excludeDates = this.getDaysWithSheets();
    }

    return (
      <DatePicker id="weekPicker"
        className="form-control form-control-sm" 
        calendarClassName="weekPopper"
        onChange={(date) => {
          this.datePicked = new Date(date);
          this.props.selectWeek(date);
        }} 
        selected={this.datePicked}
        placeholderText="Choose the week"
        maxDate={new Date()}  
        autoComplete="off" 
        shouldCloseOnSelect={true}
        excludeDates={this.excludeDates}
        withPortal
        tabIndex={0}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  timesheets: state.timesheets,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    selectWeek: (...args) => dispatch(selectWeek(...args)),
    addTimesheetDate: (...args) => dispatch(addTimesheetDate(...args)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WeeksDropdown);